var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-table',{attrs:{"data":_vm.tabelData,"pagination":true,"table-column":_vm.tableColumn},on:{"changeBypagination":_vm.tableHandle,"buttonClick":_vm.buttonClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }